<template>
  <div>
    <v-snackbar v-model="snackbar" :color="color" top :timeout="5000">
      {{text}}
      <v-btn icon @click="snackbar = false"><v-icon color="white">mdi-close</v-icon></v-btn>
    </v-snackbar>
    <search />
    <v-container fluid class="my-10 home-cont">
      <h2 class="text-center section-title secondary--text font-weight-thin text-h2 mb-2">We guarantee you</h2>
      <!-- <p class="body-2 text-center mt-5">Explore the most beautiful cities in the world with great prices</p> -->
      <v-row style="max-width: 80%;" class="my-15 mx-auto pb-15">
        <v-col cols="12" sm="6" md="4">
          <v-card min-height="200" elevation="0" class="text-center py-5">
            <img src="../static/icons/money.png" width="70">
            <v-card-title><span class="mx-auto secondary--text">Great Prices</span></v-card-title>
            <v-card-text class="primary--text">
              Most competitive prices in the industry
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4">
            <v-card min-height="200" elevation="0"  class="text-center py-5">
              <img src="../static/icons/clock.png" width="70">
              <v-card-title><span class="mx-auto secondary--text">Quick & Easy Access</span></v-card-title>
              <v-card-text class="primary--text">
                Get cheap flight tickets and hotels rooms in a simple few short clicks!
              </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4">
            <v-card min-height="200" elevation="0" class="text-center py-5">
              <img src="../static/icons/discount.png" width="70">
              <v-card-title><span class="mx-auto secondary--text">Awesome Offers</span></v-card-title>
              <v-card-text class="primary--text">
                Special offers to our loyal clients
              </v-card-text>
            </v-card>
        </v-col>
      </v-row>
      <h2 class="text-center section-title secondary--text font-weight-thin text-h2 mt-15 mb-2">Featured Trips</h2>
      <p class="body-2 text-center mt-5">Explore the most beautiful cities in the world with great prices</p>
      <featured class="mx-5"></featured>
      <v-row justify="center" class="my-5">
        <v-btn color="blueDark white--text" class="px-10 py-6" @click="$router.push({ name: 'trips' })">More Trips </v-btn>
      </v-row>
      <v-row style="max-width: 80%;" class="my-15 mx-auto pt-15" align="center" justify="space-between">
        <v-col cols="12" md="6">
          <h2 :class="$vuetify.breakpoint.mdAndUp ? 'section-title section-title__left secondary--text font-weight-thin text-h2 mb-2' : 'section-title text-center secondary--text font-weight-thin text-h2 mb-2'">Get our application</h2>
          <p :class="$vuetify.breakpoint.mdAndUp ? 'body-2 my-10' : 'body-2 my-10 text-center'">Download the Fare33 application now and freely book flights, hotels and more with the ease of your mobile.</p>
          <div :class="$vuetify.breakpoint.mdAndUp ? '' : 'mx-auto'" style="width: fit-content;">
            <a target="_blank" href="https://play.google.com/store/apps/details?id=com.fare33.fare33">
              <img src="../static/play.png" alt="DoWNLOAD ON GOOGLE PLAY">
            </a>
          </div>
        </v-col>
        <v-col cols="12" md="6" class="text-center">
          <img src="../static/mob.jpg" width="90%" alt="Fare33 Mobile App">
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// import { searchFlights, headersNoAuth } from '../links'
import featured from '../components/featured trips.vue'
import goTo from 'vuetify/es5/services/goto'
import search from '../components/searchScreen.vue'
export default {
  title: ' ',
  name: 'Home',
  components: {
    search,
    featured
  },
  data () {
    return {
      el: 1,
      length: 6,
      promotions: [],
      promotionIndex: null,
      snackbar: false,
      color: '',
      text: '',
      overlay: false
    }
  },
  methods: {
    onScroll () {
      if (window.top.scrollY === 600) {
        document.getElementById('trips').classList.add('scale-in-center')
      }
    },
    goTo (link) {
      window.open(link, '_blank')
    },
    savePromotion (flight, n) {
      this.promotionIndex = n
      this.$store.dispatch('setAirports', { data: flight.origin, type: 'departure1' })
      this.$store.dispatch('setAirports', { data: flight.destination, type: 'arrival1' })
      this.$store.dispatch('setDates', { data: flight.departureDate, type: 'departure1' })
      this.$store.dispatch('setDates', { data: flight.returnDate, type: 'arrival' })
      this.$store.dispatch('setType', 'round')
      const string = `tripType=round&origin=${flight.origin.Code}&originType=${flight.origin.Type}&destination=${flight.destination.Code}&destinationType=${flight.destination.Type}&departureDate=${flight.departureDate}&arrivalDate=${flight.returnDate}&classType=Y&adults=1`
      this.overlay = true
      this.$store.dispatch('setFlightsTimeOut', false)
      if (this.$store.state.flightsSearchTimeOutFunction !== null) this.$store.dispatch('clearFlightsSearchTimeoutFunction')
      if (this.$store.state.flightsTimeOutFunction !== null) this.$store.dispatch('clearFlightsTimeoutFunction')
      this.$store.dispatch('removeFlightResults')
      this.$router.push({ name: 'flightResults', params: { term: string } })
    },
    getCols (size) {
      if (size === 'sm') {
        const cols = this.length === 1 ? 12 : 6
        return cols
      } else {
        let cols
        switch (this.length) {
          case 1:
            cols = 12
            break
          case 2:
            cols = 6
            break
          case 3:
            cols = 4
            break
          case 4:
            cols = 3
            break
          case 6:
            cols = 4
            break
        }
        return cols
      }
    },
    getThisDate (date) {
      const givenDate = new Date(date)
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      const day = givenDate.getDate()
      return `${months[givenDate.getMonth()]} ${day}, ${givenDate.getFullYear()}`
    }
  },
  created () {
    window.scrollTo(0, 0)
    this.promotions = this.$store.state.flightPromotions
    this.length = this.promotions.length
    window.addEventListener('keydown', function (e) {
      if (e.keyCode === 34) {
        goTo(window.pageYOffset + window.innerHeight + 50)
      } else if (e.keyCode === 33) window.scrollBy(0, -100)
    })
  },
  mounted () {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  }
}
</script>

<style>
  .section-title {
    position: relative;
    line-height: 80px !important;
  }
  .section-title::after {
    content: '';
    position: absolute;
    /* margin: 50px auto; */
    width: 20%;
    height: 0.7px;
    background-color: sandybrown;
    left: 50%;
    top: 100%;
    transform: translateX(-50%);
  }
  .section-title__left::after {
    content: '';
    position: absolute;
    /* margin: 50px auto; */
    width: 50%;
    height: 0.7px;
    background-color: sandybrown;
    left: 30%;
    top: 100%;
    transform: translateX(-50%);
  }
  .home-cont {
    background-image: url('../static/map.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position-y: center;
  }
</style>
